import { useEffect, useRef, useState } from 'react'

import m from 'moment'
import Flex from '../components/utils/Flex'
import Container from '../components/utils/Container'
import TButton from '../components/utils/TWButton/TWButton'
import SendTip from '../components/SendTip'
import TModal from '../components/utils/Modal'
import UserbarUser from '../components/UserbarUser'

import ProfileThumb from '../assets/images/profile-thumb.png'

import { useSelector, useDispatch } from 'react-redux'
import { messagesSelector, msgActions } from '../store/reducers/messages.reducer'
import { classify } from '../helpers'
import Icon from '../components/utils/Icon'
import IconClose from '../components/icons/IconClose'

const Inbox = () => {

	const messagesEnd = useRef(null)
	const messages = useSelector(messagesSelector)
	const msgDispatch = useDispatch()

	const [message, setMessage] = useState('')
	const [tipModal, setTipModal] = useState(false)
	const [inboxHeight, setInboxHeight] = useState(null)

	const getHeight = cls => {
		return document
			.querySelector(cls)
			?.getBoundingClientRect()
			.height
	}

	const scrollToBottom = () => {
		setTimeout(() => {
			messagesEnd.current.scrollIntoView({ behavior: "smooth" });
		}, 100);
	}

	const handleSendMessage = () => {
		msgDispatch(msgActions.PUSH(['messages.data', {
			id: Date.now(),
			type: 'text',
			sender: {
				id: 'me',
				avatar: ProfileThumb
			},
			text: message,
			createdAt: new Date().toISOString()
		}]))
		setMessage('')
		scrollToBottom()
	}

	const handleSendPhoto = () => {
		const input = document.createElement('input')
		input.type = 'file'
		input.accept = "image/x-png,image/gif,image/jpeg"
		input.addEventListener('change', ev => {
			const file = ev.target.files[0]
			msgDispatch(msgActions.PUSH(['messages.data', {
				id: Date.now(),
				type: 'image',
				sender: {
					id: 'me',
					avatar: ProfileThumb
				},
				src: URL.createObjectURL(file),
				createdAt: new Date().toISOString()
			}]))
			scrollToBottom()
		})
		input.click()
	}

	useEffect(() => {
		const calcInboxHeight = () => {
			setInboxHeight(getHeight('.default-layout__ps') -
				['.inbox__bottom', '.inbox__userbar']
					.reduce((height, cls) => height + getHeight(cls), 0)
				- 4
			)
			scrollToBottom()
		}
		window.onresize = calcInboxHeight
		setTimeout(() => { calcInboxHeight() }, 300);
	}, [])

	return (
		<div className="inbox">
			<Container>
				<UserbarUser className="inbox__userbar py-2" />
			</Container>
			<Flex className="relative">
				<aside
					className="absolute lg:relative inset-y-0 left-0 w-14 bg-secondary lg:bg-transparent z-50 lg:w-96 border-t-4 lg:border-r-4 border-secondary2 py-4 px-1 lg:p-4 flex-shrink-0 overflow-hidden flex flex-col items-center"
				>
					<Flex
						items-center
						className="bg-blue-500 rounded p-1 lg:p-2 mb-3 cursor-pointer relative"
					>
						<Icon className='absolute top-2 right-2 w-5 h-5 cursor-pointer'>
							<IconClose />
						</Icon>
						<img
							src={ProfileThumb}
							alt="User profile pic"
							className="h-8 w-8 lg:h-14 lg:w-14 rounded-full lgrounded object-center object-cover"
						/>
						<div className="ml-4 hidden lg:block">
							<h4 className="font-bold text-lg">UserName</h4>
							<p className="text-secondary">Lorem ipsum dolor sit amet, co..</p>
						</div>
					</Flex>
					<Flex items-center className="rounded p-1 lg:p-2 mb-3 cursor-pointer relative">
						<Icon className='absolute top-2 right-2 w-5 h-5 cursor-pointer'>
							<IconClose />
						</Icon>
						<img
							src={ProfileThumb}
							alt="User profile pic"
							className="h-8 w-8 lg:h-14 lg:w-14 rounded-full lgrounded object-center object-cover"
						/>
						<div className="ml-4 hidden lg:block">
							<h4 className="font-bold text-lg">UserName</h4>
							<p className="text-secondary">Lorem ipsum dolor sit amet, co..</p>
						</div>
					</Flex>
					<Flex items-center className="rounded p-1 lg:p-2 mb-3 cursor-pointer relative">
						<Icon className='absolute top-2 right-2 w-5 h-5 cursor-pointer'>
							<IconClose />
						</Icon>
						<img
							src={ProfileThumb}
							alt="User profile pic"
							className="h-8 w-8 lg:h-14 lg:w-14 rounded-full lgrounded object-center object-cover"
						/>
						<div className="ml-4 hidden lg:block">
							<h4 className="font-bold text-lg">UserName</h4>
							<p className="text-secondary">Lorem ipsum dolor sit amet, co..</p>
						</div>
					</Flex>
				</aside>
				<div
					className="pl-14 lg:pl-0 relative border-t-4 flex-auto border-secondary2"
				>
					<div className='overflow-y-auto scrollbar-y' style={{ height: `${inboxHeight}px` }}>
						<div className="px-3 lg:px-12 py-4">
							{messages.data.map(msg => (
								<Flex key={msg.id} flex-row-reverse={msg.sender.id === 'me'} className="mb-8">
									<img
										alt="Sender avatar"
										src={msg.sender.avatar}
										className="h-7 lg:h-14 w-7 lg:w-14 rounded object-center object-cover flex-shrink-0"
									/>
									<div className={classify([msg.sender.id === 'me' ? "mr-4" : 'ml-4'])}>
										{msg.type === 'image' ? (
											<img
												alt=''
												src={msg.src}
												className="w-96 mb-4 rounded shadow"
											/>
										) : (
											<p className="p-2 lg:p-4 bg-secondary2 rounded shadow text-sm lg:text-base" >
												{msg.text}
											</p>
										)}
										<p className="text-sm text-secondary mt-1">
											{/* 3:32 pm 6/27/2020 */}
											{m(msg.createdAt).format('HH:mm A DD/MM/YYYY')}
										</p>
									</div>
								</Flex>
							))}
						</div>
						<div ref={messagesEnd} style={{ float: "left", clear: "both" }}>
						</div>
					</div>
					<div
						className="inbox__bottom py-2 px-4 bg-primary border-t-4 border-secondary2"
					>
						<input
							value={message}
							placeholder="Type your message here"
							onChange={e => setMessage(e.target.value)}
							className="w-full bg-primary text-lg py-2"
						/>
						<Flex itemsCenter className="py-3 flex-wrap">
							<TButton onClick={handleSendPhoto} outlined text size="sm" className="mr-4">
								<i className="material-icons mr-0 sm:mr-2 md-18"
								>insert_photo</i
								>
								<span className="hidden sm:block">Add Media</span>
							</TButton>
							<TButton onClick={() => setTipModal(true)} outlined text size="sm">
								<i className="material-icons mr-1 sm:mr-2 md-18"
								>monetization_on</i
								>
								Send a tip
							</TButton>
							<TButton onClick={handleSendMessage} size="sm" className="ml-auto px-3 md:px-8">
								Send
								<i className="material-icons ml-2 text-base">send</i>
							</TButton>
						</Flex>
					</div>
				</div>
			</Flex>
			<TModal
				showClose
				className="modal"
				backgroundClose
				value={tipModal}
				onClose={() => setTipModal(false)}
			>
				<SendTip onCancel={() => setTipModal(false)} />
			</TModal>
		</div>
	)
}

export default Inbox